import {Component, inject} from '@angular/core';
import {DxDateRangeBoxModule, DxTabsModule} from 'devextreme-angular';
import {AccessType, AuthService, PermissionType} from '@services';
import {DashboardAccess} from './dashboard-access';
import {DashboardVolumesComponent} from './volumes/dashboard-volumes.component';
import {DashboardOurTeamComponent} from './our-team/dashboard-our-team.component';
import {DashboardOurYardComponent} from './our-yard/dashboard-our-yard.component';
import {DashboardInboundComponent} from './inbound/dashboard-inbound.component';
import {DashboardInventoryComponent} from './inventory/dashboard-inventory.component';
import {DashboardOutboundComponent} from './outbound/dashboard-outbound.component';

enum TabType {
    Volumes = 'Volumes',
    OurTeam = 'OurTeam',
    OurYard = 'OurYard',
    Inbound = 'Inbound',
    Inventory = 'Inventory',
    Outbound = 'Outbound',
}

type Tab = {type: TabType; text: string};

@Component({
    selector: 'app-dashboard',
    imports: [
        DxTabsModule,
        DxDateRangeBoxModule,
        DashboardVolumesComponent,
        DashboardOurTeamComponent,
        DashboardOurYardComponent,
        DashboardInboundComponent,
        DashboardInventoryComponent,
        DashboardOutboundComponent,
    ],
    providers: [DashboardAccess],
    templateUrl: './dashboard.component.html',
})
export class DashboardComponent {
    private auth = inject(AuthService);
    private access = inject(DashboardAccess);

    protected readonly TabType = TabType;

    protected readonly tabs: Tab[] = this.auth.checkPermission(PermissionType.DashboardMyScore, AccessType.ViewOnly)
        ? [
            {type: TabType.Volumes, text: 'Volumes', visible: this.access.volumes},
            {type: TabType.OurTeam, text: 'Our Team', visible: this.access.ourTeam},
            {type: TabType.OurYard, text: 'Our Yard', visible: this.access.ourYard},
            {type: TabType.Inbound, text: 'Inbound', visible: this.access.inbound},
            {type: TabType.Inventory, text: 'Inventory', visible: this.access.inventory},
            {type: TabType.Outbound, text: 'Outbound', visible: this.access.outbound},
        ].filter(tab => tab.visible)
        : [];

    protected selectedTab: Tab | undefined = this.tabs[0];

    protected dateRange: [Date, Date] = DashboardComponent.lastSevenDays();

    private static lastSevenDays(): [Date, Date] {
        const today = new Date(new Date().setHours(0, 0, 0, 0));
        const start = new Date(today);
        start.setDate(today.getDate() - 7);
        return [start, today];
    }

    protected onTabClick(tab: Tab): void {
        this.selectedTab = tab;
    }
}
